<template>
  <!-- 床位管理的表单弹框 -->
  <!-- tips：这里使用 v-bind="$attrs" v-on="$listeners" 将父组件的属性和事件直接透传给孙子组件，就不用在当前组件里编写中转逻辑了 -->
  <BuildForm v-if="level == 'building'" v-bind="$attrs" v-on="$listeners"></BuildForm>
  <FloorForm v-else-if="level == 'floor'" v-bind="$attrs" v-on="$listeners"></FloorForm>
  <RoomForm v-else-if="level == 'room'" v-bind="$attrs" v-on="$listeners"></RoomForm>
  <BedForm v-else-if="level == 'bed'" v-bind="$attrs" v-on="$listeners"></BedForm>
</template>

<script>
import BuildForm from './buildingForm';
import FloorForm from './floorForm';
import RoomForm from './roomForm';
import BedForm from './bedForm';

export default {
  name: 'BedManageForm',
  props: ['level'],
  components: {
    BuildForm,
    FloorForm,
    RoomForm,
    BedForm,
  },
};
</script>

<style lang="scss" scoped></style>
